import React, {useState} from 'react';
import {AppUser} from "models/app";
import {ProprietarioObject} from "models/Proprietario";
import BuscaNome from "./BuscaNome";
import BuscaTelefone from "./BuscaTelefone";
import {ModalBodyPart} from "components/Modal";
import {useFazendasIndexProprietarios} from "../../../lib/DataHooks/fazendas";
import {IonProgressBar} from "@ionic/react";

interface BuscaProps {
  user: AppUser;
  preCadastro?: any;
  onNotFound: (values: any) => void;
  proprietarios: ProprietarioObject[];
  onSelect?: (prop: ProprietarioObject) => void;
  onClickBack?: () => void;
}

export const MIN_NOME_LENGTH = 3;

type BuscaState = 'nome' | 'telefone';

const Busca: React.FC<BuscaProps> = (props) => {
  const {user, onNotFound, preCadastro, proprietarios, onSelect,
    onClickBack} = props;
  const [buscaState, setBuscaState] = useState<BuscaState>(preCadastro?.telefone ? 'telefone' : 'nome');
  const [nome, setNome] = useState<string>(preCadastro?.nome);
  const [telefone, setTelefone] = useState<string>(preCadastro?.telefone);
  const [indexProps, indexPropsIsLoading] = useFazendasIndexProprietarios({userId: user.uid});

  const getContent = () => {
    if (buscaState === 'nome') {
      return (
        <BuscaNome
          user={user}
          proprietarios={proprietarios}
          onSelect={onSelect}
          initialNome={nome}
          indexProprietarios={indexProps}
          onNotfound={(_nome) => {
            setNome(_nome);
            setBuscaState('telefone');
          }}
          onClickBack={onClickBack}
        />
      );
    }

    if (buscaState === 'telefone') {
      return (
        <BuscaTelefone
          user={user}
          proprietarios={proprietarios}
          onSelect={onSelect}
          indexProprietarios={indexProps}
          onClickBack={() => {
            // console.log('onClickBack');
            // se temos onClickBack, então o usuário está no formulário de cadastro
            if (onClickBack) {
              onClickBack();
              return;
            }
            setBuscaState('nome')
          }}
          initialTelefone={telefone}
          onNotfound={(_telefone) => {
            // console.log('onNotfound', _telefone);
            setTelefone(_telefone);
            onNotFound({nome, telefone: _telefone});
          }}
        />
      );
    }

    // console.log('Busca: invalid state', buscaState);
    return null;
  }

  if (!buscaState) {
    // console.log('Busca NONE: invalid state', buscaState);
    return null;
  }

  return (
    <ModalBodyPart>
      {indexPropsIsLoading &&
        <IonProgressBar type="indeterminate"/>
      }
      {!indexPropsIsLoading &&
        getContent()
      }
    </ModalBodyPart>
  );
}

export default Busca;





